import React from 'react';

import styled from 'styled-components';

import { useLayoutContext } from '@contexts/LayoutContext';

import AddressLine from '@components/Addresses/AddressLine';
import NwIcon from '@components/Gui/NwIcon';
import NwSlickSlider from '@components/Gui/NwSlickSlider';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const AddressSelectContainer = styled.div`
    padding: 2rem 1.5rem;
    .slick-arrow {
        top: 3rem;
    }
    .slick-track {
        .slick-slide {
            padding: 0 0.5rem;
            box-sizing: border-box;

            .connection-name {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                gap: 0.5rem;
                h4 {
                    margin: 0;
                }
                margin-bottom: 0.5rem;
            }
        }
    }
    .no-addresses {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: ${(props) => props.theme.DangerColor};
        text-transform: uppercase;
        gap: 1rem;

        p {
            margin: 0;
        }
        span {
            font-size: ${(props) => props.theme.FontSizeLg};
        }
    }
    .add-new-icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        font-size: 2rem;
        color: ${(props) => props.theme.PrimaryColor};
        height: 6rem;
        h4 {
            font-size: ${(props) => props.theme.FontSizeBase};
        }
    }
`;

const Slide = styled.div`
    position: relative;
    padding: 0.5rem 0.5rem 2.5rem;
    min-height: 12rem;
    cursor: pointer;
    border: ${(props) => (props.$selected ? `2px solid ${props.theme.PrimaryColor}` : props.theme.DefaultBorder)};
    border-radius: 0.5rem;
`;

const AddressFromContacts = ({ selectedAddress, addresses, onChange, onAdd }) => {
    const layoutcontext = useLayoutContext();
    const { isMobile } = layoutcontext;

    const renderIcon = (connectionType) => {
        //to check: maybe to update
        switch (connectionType) {
            case 'Place':
                return <NwIcon icon={byPrefixAndName.fasl['home-alt']} />;
            case 'People':
                return <NwIcon icon={byPrefixAndName.fasl['user']} />;
            case 'Room':
                return <NwIcon icon={byPrefixAndName.fasl['suitcase-rolling']} />;
            default:
                return <NwIcon icon={byPrefixAndName.fasl['home-alt']} />;
        }
    };

    return (
        <AddressSelectContainer>
            {addresses && addresses.length > 0 ? (
                <NwSlickSlider
                    slidesToShow={isMobile ? 1 : 3}
                    slidesToScroll={isMobile ? 1 : 3}
                    variableWidth={false}
                    adaptiveHeight
                >
                    {addresses.map((address, index) => (
                        <Slide
                            $selected={address.ID === selectedAddress}
                            key={index}
                            index={index}
                            onClick={() => onChange(address)}
                        >
                            <div className="connection-name">
                                <span>{renderIcon(address.ConnectionType)}</span>
                                <h4>{address.ConnectionName}</h4>
                            </div>
                            <AddressLine address={address} inLocationSelector />
                        </Slide>
                    ))}
                    <Slide
                        $selected={selectedAddress === 'add-new'}
                        key="add-new"
                        index={addresses.length}
                        onClick={() => onAdd()}
                    >
                        <div className="connection-name"></div>
                        <div className="add-new-icon">
                            <h4 style={{ textAlign: 'center' }}>add a new address</h4>
                            <NwIcon primary icon={byPrefixAndName.fass['plus-circle']} />
                        </div>
                    </Slide>
                </NwSlickSlider>
            ) : (
                <div className="no-addresses">
                    <span>
                        <NwIcon icon={byPrefixAndName.fass['location-dot-slash']} />
                    </span>
                    <p>no addresses found</p>
                </div>
            )}
        </AddressSelectContainer>
    );
};

export default AddressFromContacts;
